// Slovník zakázaných výrazů

import {
  deleteBadWords as deleteWords,
  toggleBadwordsList as toggleList,
} from './forumBadWordsUtils';
import { submitBadWords as submit } from './forumBadWordsSubmit';

export const forumBadWords = () => {
  // Zobrazit/skrýt seznam zakázaných výrazů
  toggleList();

  // Odebrat staré slovo pomocí křížku
  deleteWords();

  // Zpracovat odeslání formuláře
  submit();
};
